import { handleActions } from 'redux-actions';
import { userAuthenticated } from '../actions';

const initialState = {
    account: undefined,
    getAccessToken: undefined,
    authorizationScopes: {},
};

export default handleActions(
    {
        [userAuthenticated]: (state, action) => ({
            ...state,
            ...action.payload,
        }),
    },
    initialState,
);
